import CreateConsultSecondStepItem from './CreateConsultSecondStepItem/CreateConsultSecondStepItem';
import { useCallback, useContext, useEffect , useMemo, useState } from 'react';
import {
  CreateConsultSecondStepItemData,
  CreateConsultSecondStepMutation,
} from './CreateConsultSecondStep.types';
import { useNavigate, useParams } from 'react-router-dom';
import { ADD_PRESTATIONS_QUERY_KEY, queryAddPrestations } from './CreateConsultSecondStep.query';
import { useMutation, useQueryClient } from 'react-query';
import Button from '../../../../designSystem/Button/Button';
import { ConsultationType } from '../../../../../types/models/consultations/consultation.types';
import { useConsultationSummary } from '../../../../../hooks/fetchers/useConsultationSummary/useConsultationSummary';
import { StepWizardContext } from '../../../../commons/StepWizard/StepWizard.context';
import '../../../../../styles/CreateConsult.css';
import { ButtonColor } from '../../../../designSystem/Button/Button.types';
import TextArea from '../../../../commons/TextArea/TextArea';
import { useDropzone } from 'react-dropzone';
import { ConsultationItemType } from './CreateConsultSecondStepItem/CreateConsultSecondStepItem.types';

export const emptyVenteData = {
  type: ConsultationItemType.Products,
  quantity: 1,
  description: '',
};

export const emptyServiceData = (type: ConsultationItemType) => ({
  type,
  quantity: null,
  description: '',
});

// export const emptyLesDeuxData = {
//   type: ConsultationType.LesDeux,
//   quantity: null,
//   description: ''
// }

export default () => {
  const { consultationId } = useParams();
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { setCurrentStep } = useContext(StepWizardContext);

  const { acceptedFiles, getRootProps, getInputProps, fileRejections } = useDropzone({
    multiple: true,
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg'],
      'application/pdf': ['.pdf'],
    },
    maxSize: 5 * 1024 * 1024
  });

  useEffect(() => {
    if (fileRejections.length > 0) {
      fileRejections.map((file) => {
        const isFileTooLarge = Boolean(file.errors.find(({ code }) => code === 'file-too-large'))
        if (isFileTooLarge) {
          alert('Ce fichier est trop grand (max 5 Mo).')
        }
      })
    }
  }, [fileRejections])

  const [furtherDescription, setFurtherDescription] = useState<string>();

  const { data } = useConsultationSummary(parseInt(consultationId as string), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(consultationId),
  });

  // const defaultEmptyData = useMemo(() => {
  //   if (data) {
  //     if (data.prestations.length > 0) {
  //       return data.prestations;
  //     } else {
  //       switch (data.infos.type) {
  //         case ConsultationType.Fournitures:
  //           return [emptyVenteData];
  //         case ConsultationType.TravauxBatiment:
  //           return [emptyServiceData(data.infos.type)];
  //         case ConsultationType.TravauxPublics:
  //           return [emptyServiceData(data.infos.type)];
  //         case ConsultationType.Services:
  //           return [emptyServiceData(data.infos.type)];
  //         default:
  //           return [emptyVenteData];
  //       }
  //     }
  //   } else {
  //     return [];
  //   }
  // }, [data]);

  const defaultEmptyData = useMemo(() => {
    if (data) {
      if (data.prestations.length > 0) {
        return data.prestations;
      } else {
        return [emptyVenteData];
      }
    } else {
      return [];
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      if (data.infos.further_description) {
        setFurtherDescription(data.infos.further_description)
      }
      // if (data.prestations.length > 0) {
      //   setItems(data.prestations);
      // } else {
      //   if (data.infos.type === ConsultationType.Fournitures) {
      //     setItems([emptyVenteData]);
      //   } else {
      //     setItems([emptyServiceData(data.infos.type)]);
      //   }
      // }
    }
  }, [data]);

  // @ts-ignore
  const [items, setItems] = useState<CreateConsultSecondStepItemData[]>(defaultEmptyData);

  const onChange = (indexToUpdate: number, data: CreateConsultSecondStepItemData) => {
    const updatedItems = items.reduce((acc, item, index) => {
      if (index === indexToUpdate) {
        return [...acc, data];
      } else {
        return [...acc, item];
      }
    }, [] as CreateConsultSecondStepItemData[]);
    setItems(updatedItems);
  };

  const onAdd = (type: ConsultationItemType) => {
    switch (type) {
      case ConsultationItemType.Products:
        return setItems([...items, emptyVenteData]);
      default:
        return setItems([...items, emptyServiceData(type)]);
    }
  };

  const onRemove = (indexToRemove: number) => {
    const newItems = items.reduce((acc, item, index) => {
      if (index !== indexToRemove) {
        return [...acc, item];
      } else {
        return acc;
      }
    }, [] as CreateConsultSecondStepItemData[]);
    setItems(newItems);
  };

  const { mutate } = useMutation<
    Awaited<ReturnType<CreateConsultSecondStepMutation>>,
    Error,
    FormData
  >((data) => queryAddPrestations(parseInt(consultationId as string), data), {
    mutationKey: ADD_PRESTATIONS_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      setCurrentStep(3);
      navigate(`/dashboard/nouvelle_consultation/${consultationId}`);
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  const onSubmit = useCallback(() => {
    const formData = new FormData();
    console.log('acceptedFiles', acceptedFiles)
    for (const file of acceptedFiles) {
      formData.append('files', file);
    }
    if (furtherDescription) {
      formData.append('furtherDescription', furtherDescription);
    }
    formData.append('items', JSON.stringify(items));
    mutate(formData);
  }, [items, furtherDescription, acceptedFiles]);

  return (
    <form className="form">
      {items.map((item, index) => {
        return (
          <CreateConsultSecondStepItem
            key={index}
            type={data?.infos.type || ConsultationType.Services}
            isLast={index === items.length - 1}
            data={item}
            {...{ index, onChange, onAdd, onRemove }}
          />
        )
      })}
      <TextArea 
        placeholder='Informations supplémentaires...'
        style={{ 
          border: '1px solid var(--gray-4)',
          marginBottom: 'var(--spacing-s)',
          minHeight: 64
        }} 
        defaultValue={furtherDescription}
        onChange={e => setFurtherDescription(e.target.value)}
      />
      <div style={{ marginBottom: 'var(--spacing-s)' }} {...getRootProps({ className: 'dropzone register__dropzone' })}>
        <input {...getInputProps()} />
        <p>
          Vous pouvez ajouter des <strong>pièces jointes</strong> ici
        </p>
        <span id='limit'>
          Types de fichiers acceptés: <span className='text-primary'>.jpg<span id='separator'>,</span> .jpeg<span id='separator'>,</span> .png<span id='separator'>,</span> .pdf</span> <span id='size'>(max. 5 Mo)</span>
        </span>
        {acceptedFiles.length > 0 && acceptedFiles.map((file, index) => (
          <span key={index}>{file.name}</span>
        ))}
      </div>
      <Button
        style={{ marginBottom: 'var(--spacing-s)' }}
        color={ButtonColor.Contrast}
        onClick={(e) => {
          e.preventDefault();
          navigate('/dashboard/consultations');
        }}>
        Continuer plus tard
      </Button>
      <Button
        style={{ marginBottom: 'var(--spacing-s)' }}
        onClick={(e) => {
          e.preventDefault();
          setCurrentStep(1);
        }}>
        Précedent
      </Button>
      <Button
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}>
        Suivant
      </Button>
    </form>
  );
};
